import React from 'react';

const ChevronsRightIcon = () => {
	return (
		<svg
			data-testid='chevrons'
			fill='none'
			height='20'
			viewBox='0 0 20 20'
			width='20'
		>
			<path
				d='M10.8333 14.1666L15 9.99996L10.8333 5.83329'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M5.83333 14.1666L10 9.99996L5.83333 5.83329'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ChevronsRightIcon;
